import { FC } from 'react';
import { useOutBoundSyncSubscription, useToolOrderUpdateSubscription } from '~/hooks/subscription/intex';
import { useToolInventoryUpdate } from '~/hooks/subscription/use-tool-inventory-update';

// Subscription manager wires all the real time notifications and relavant cache updates
export const ToolOrderSubscriptionManager: FC = () => {
  useToolOrderUpdateSubscription();
  return null;
};
export const ToolInventorySubscriptionManager: FC = () => {
  useToolInventoryUpdate();
  return null;
};
export const OutboundSubscriptionManager: FC = () => {
  useOutBoundSyncSubscription();
  return null;
};
